module.exports = __webpack_public_path__ + "img/bg_striped_blue.1dab984.webp";